import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ContactBanner from './components/ContactBanner';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import ContactMap from './components/ContactMap';

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <ContactBanner />

        {/* Info Cards */}
        <section className="w-full bg-[#f5f8fc] py-12 px-4">
          <div className="max-w-5xl mx-auto">
            {/* Section Title */}
            <div className="flex items-center justify-center gap-4 mb-2">
              <span className="text-[#1a73b5] text-2xl leading-none">&#8942;</span>
              <h2 className="text-3xl font-bold text-gray-800 tracking-wider">聯絡資訊</h2>
              <span className="text-[#1a73b5] text-2xl leading-none">&#8942;</span>
            </div>
            <p className="text-center text-sm tracking-[0.3em] text-gray-400 uppercase mb-8">CONTACT INFORMATION</p>
            <div className="flex items-center mb-10">
              <div className="flex-1 h-px bg-[#1a73b5]" />
              <div className="w-2 h-2 bg-[#1a73b5] rotate-45 mx-1" />
              <div className="flex-1 h-px bg-[#1a73b5]" />
            </div>
            <ContactInfo />
          </div>
        </section>

        {/* Form + Map */}
        <section className="w-full bg-white py-14 px-4">
          <div className="max-w-5xl mx-auto">
            {/* Section Title */}
            <div className="flex items-center justify-center gap-4 mb-2">
              <span className="text-[#1a73b5] text-2xl leading-none">&#8942;</span>
              <h2 className="text-3xl font-bold text-gray-800 tracking-wider">線上詢問</h2>
              <span className="text-[#1a73b5] text-2xl leading-none">&#8942;</span>
            </div>
            <p className="text-center text-sm tracking-[0.3em] text-gray-400 uppercase mb-8">ONLINE INQUIRY</p>
            <div className="flex items-center mb-10">
              <div className="flex-1 h-px bg-[#1a73b5]" />
              <div className="w-2 h-2 bg-[#1a73b5] rotate-45 mx-1" />
              <div className="flex-1 h-px bg-[#1a73b5]" />
            </div>

            <div className="flex flex-col lg:flex-row gap-10 items-start">
              {/* Form */}
              <div className="flex-1 w-full">
                <ContactForm />
              </div>
              {/* Map */}
              <div className="w-full lg:w-[380px] flex-shrink-0">
                <ContactMap />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
